/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IgnoredTombstoneOrHideContainer_viewer = {
    readonly ignoredUsers: ReadonlyArray<{
        readonly id: string;
    }>;
    readonly " $refType": "IgnoredTombstoneOrHideContainer_viewer";
};
export type IgnoredTombstoneOrHideContainer_viewer$data = IgnoredTombstoneOrHideContainer_viewer;
export type IgnoredTombstoneOrHideContainer_viewer$key = {
    readonly " $data"?: IgnoredTombstoneOrHideContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"IgnoredTombstoneOrHideContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IgnoredTombstoneOrHideContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "ignoredUsers",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '86b42da1a3c713be301c0c1a67dbf950';
export default node;
